import { Injector, NgModule } from "@angular/core";
import { HomeComponent } from "./home/home.component";
import { AppComponent } from "./app.component";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ImageWithTitleComponent } from "./shared/imageWithTitle/image-with-title.component";
import { CustomErrorComponent } from "./shared/error-page/custom-error-page.component";
import { environment } from "../environments/environment";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HeaderComponent, MenuComponent, NextPage } from "@cvx/nextpage";
import { AppRoutingModule } from "./app-routing.module";
import { ActionButtonComponent } from "./shared/action-button/action-button.component";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalAngularModule } from "@cvx/cal-angular";
import { TokenInterceptor } from "./interceptors/token-interceptor";
import { RouterModule } from "@angular/router";

const componentList = [
  AppComponent,
  HomeComponent,
  ImageWithTitleComponent,
  CustomErrorComponent,
  ActionButtonComponent,
  SpinnerComponent
];

@NgModule({ 
  declarations: [componentList],
  exports: [
      MenuComponent,
      HeaderComponent,
      AppRoutingModule,
      BrowserModule,
      FormsModule,
      ReactiveFormsModule,
      BrowserAnimationsModule
  ],
  bootstrap: [AppComponent], 
  imports: [
      BrowserModule,
      FormsModule,
      BrowserAnimationsModule,
      NextPage,
      RouterModule,
      CalAngularModule.forRoot({
        autoSignIn: environment.autoSignIn,
        popupForLogin: environment.popupForLogin,
        cacheLocation: environment.cacheLocation,
        instance: environment.instance,
        tenantId: environment.tenantId,
        clientId: environment.clientId,
        redirectUri: environment.redirectUri,
        oidcScopes: environment.oidcScopes,
        graphScopes: environment.graphScopes
      })], 
  providers: [
    provideHttpClient(withInterceptors([TokenInterceptor])),
  ]
})

export class AppTest {
  constructor(private injector: Injector) {}
}